import {
  toLandingPageBlackFridayLink,
  toLandingPageSeasonalLink,
} from 'lib/links';

import { getCouponsList } from 'services/coupon';
import { getSelectionOffersList } from 'services/selection';
import { getStoreCouponsList } from 'services/store';

const BLACK_FRIDAY_PARAM = 'black-friday';

const getCategoryLandingUrl = (categoryOrSubcategory, type, landingSlug) => {
  if (landingSlug === BLACK_FRIDAY_PARAM) {
    return toLandingPageBlackFridayLink(categoryOrSubcategory, type);
  }

  return toLandingPageSeasonalLink(categoryOrSubcategory, type, landingSlug);
};

const normalizeLandingItems = (
  { id, name, slug },
  type,
  landingSlug,
  asPath
) => {
  const href = getCategoryLandingUrl(slug, type, landingSlug);

  return {
    id,
    name,
    slug,
    type,
    href,
    active: asPath === href,
  };
};

export const getCategoriesLandings = ({
  asPath,
  homeLandingItem,
  landingCategories,
  landingSlug,
}) => {
  const allCategories = [
    ...landingCategories.categories.map((category) =>
      normalizeLandingItems(
        {
          id: category.categoryId,
          name: category.categoryName,
          slug: category.categorySlug,
        },
        'category',
        landingSlug,
        asPath
      )
    ),
    ...landingCategories.subcategories.map((subcategory) =>
      normalizeLandingItems(
        {
          id: subcategory.subcategoryId,
          name: subcategory.subcategoryName,
          slug: subcategory.subcategorySlug,
        },
        'subcategory',
        landingSlug,
        asPath
      )
    ),
  ];

  if (!asPath.endsWith(`/${landingSlug}/`)) {
    allCategories.unshift(homeLandingItem);
  }

  const matchedIndex = allCategories.findIndex(({ slug, type }) => {
    const categoryPath = getCategoryLandingUrl(landingSlug, slug, type);
    return asPath === categoryPath;
  });

  if (matchedIndex > -1) {
    const matchedCategory = allCategories[matchedIndex];
    return [
      matchedCategory,
      ...allCategories.filter((_, index) => index !== matchedIndex),
    ];
  }

  return allCategories;
};

export const injectSsrInitialProps = async (modularLanding) => {
  const components = [];

  for (const component of modularLanding.components) {
    if (component.type === 'offer_selections') {
      const timelineId = component.data.id;
      const offers = await getSelectionOffersList({
        slug: timelineId,
        limit: 8,
      });

      components.push({
        ...component,
        offers,
      });
      continue;
    }

    if (component.type === 'coupon_pages') {
      const endpoint = component.data.link;
      const storeSlug = endpoint.match(/\/stores\/([^/]+)/)?.[1] || null;

      if (storeSlug) {
        const coupons = await getStoreCouponsList({
          limit: 3,
          page: 1,
          storeSlug,
        });

        component.props = {
          ...component.props,
          storeSlug,
          coupons,
        };
        components.push(component);
        continue;
      }

      const coupons = await getCouponsList({ limit: 3, sort: 'best' });

      component.props = {
        ...component.props,
        coupons,
      };
      components.push(component);
      continue;
    }

    components.push(component);
  }

  modularLanding.components = components;

  return modularLanding;
};
